import { cloneDeep, findIndex, has } from 'lodash'

import { StepperGroup } from 'views/AdjustersHub/ClaimView/components/Stepper/interface'

export default function getInActiveStepsState(steps: StepperGroup): StepperGroup {
  const stepsClone = cloneDeep(steps)

  const activeGroupIndex = findIndex(stepsClone, { isActive: true })!
  const activeGroup = stepsClone[activeGroupIndex]

  activeGroup.isActive = false

  if (has(activeGroup, 'steps')) {
    const activeSubStepIndex = findIndex(activeGroup.steps, { isActive: true })!

    if (activeSubStepIndex >= 0) {
      activeGroup.steps![activeSubStepIndex].isActive = false
    }
  }

  return stepsClone
}
